import { hasRevolvingCreditFacilityProduct } from './products';

export function getMaxLoanSizeForProduct(application, country) {
    if (hasRevolvingCreditFacilityProduct(application)) {
        return country === 'uk' ? 1000000 : 500000;
    }

    throw new Error("Product not defined, can't return max loan size.");
}
